export const GET_POST = 'news/GET_POST';



// WEBPACK FOOTER //
// ./src/redux/Post/constants.js